import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ApiError, ExportModuleSourceResult } from '../types/showcase';

/**
 * Mutation: GET /api/eraf/catalog/modules/{code}/export (queue #631)
 * 성공 시 blob+filename 을 반환 — 호출부(TakeThisPanel)가 브라우저 다운로드를 트리거한다.
 */
export function useExportModuleSource() {
  return useMutation<ExportModuleSourceResult, ApiError, string>({
    mutationFn: (code) => showcaseApi.exportModuleSource(code),
    mutationKey: ['common-showcase', 'export-source'],
  });
}
